
import React, { useEffect, useState } from "react";
import { useSubheader } from "@metronic/layout";
import {
  Alert,
  Col,
  Row,
  Card,
  Accordion,
  Button,
  Form,
} from "react-bootstrap";
import {Redirect, useHistory} from "react-router-dom";
import axios from "axios";
import { InssuredData } from "@components/panels/insured-data/inssured-data";
import { HospitalData } from "@components/panels/hospital-data/hospital-data";
import { Documentation } from "@components/panels/documentation/documentation";
import { Binnacle } from "@components/panels/binnacle/binnacle";
import { SufferingData } from "@components/panels/suffering-data/suffering-data";
import AuthLetters from "@components/panels/auth-letter/auth-letters";
import { getBySlug, update } from "@services/hospitalization";
import { getLasMcMovementtByCase } from "@services/mc-movements";
import { getLastLetterMovByCase } from "@services/letter-movements";
import CaseHeader from "@components/panels/case-header/case-header";
import BlockCaseContext from "@contexts/block-case-context";
import WithCommentValidation from "@components/shared/with-comment-validation";
import $ from "jquery";
import {isCaseInCorrectModule} from "@utils/check-module-status";
import {CASE_STATUS, EVENT_STAGES} from "@constants/case-statuses";
import {HospitalSupervision} from "@components/panels/hospital-supervision/hospital-supervision";
import {isEmpty} from "@utils/check-object-empty";

const HospitalSupervisionDetails = (props) => {
  const [caseRecord, setCaseRecord] = useState({});
  const [mcMovement, setMcMovement] = useState({});
  const [letterMov, setLetterMov] = useState({});
  const [totalLetters, setTotalLetters] = useState(0);
  const [shouldBlockCase, setShouldBlockCase] = useState(true);


  const subheader = useSubheader();
  const { slug } = props.match.params;

  let submitFormHospitalSupervision = null;
  let submitFormHospitalSupervisionErrors = null;

  const bindSubmitFormHospitalSupervision = (submitForm) =>
    (submitFormHospitalSupervision = submitForm);

  const bindSubmitFormHospitalSupervisionErrors = (errors) =>
    (submitFormHospitalSupervisionErrors = errors);

  useEffect(() => {
    getBySlug(slug).then((response) => {
      setCaseRecord(response.data);
      getLasMcMovementtByCase(response.data.id).then((currentMcMovemet) =>
        setMcMovement(currentMcMovemet.data)
      );
      getLastLetterMovByCase(response.data.id).then((currrentLetterMov) =>
        setLetterMov(currrentLetterMov.data)
      );
    });

    subheader.setTitle("Supervision Hospitalaria");
  }, []);

  let history = useHistory();

  const query = new URLSearchParams(props.location.search);

  const onClickSendDictum = async () => {
    if (submitFormHospitalSupervision !== null) {
      await submitFormHospitalSupervision();
    }

    if (!isEmpty(submitFormHospitalSupervisionErrors)) {
      return;
    }

    const inputReason = document.getElementById("reason_sendToX").value;
    if (inputReason === "") {
      alert("Debe seleccionar una razon");
      return;
    }

    $("#btn_save_comment").click();
    update({ caseStatusId: CASE_STATUS.MEDICAL_OPINION, reasonHospitalSupervision: inputReason}, caseRecord.id).then((response) => {
      history.push("/dictamen_medico");
    });
  }

  const onClickSendControlDesk = async () => {
    if (submitFormHospitalSupervision !== null) {
      await submitFormHospitalSupervision();
    }

    if (!isEmpty(submitFormHospitalSupervisionErrors)) {
      return;
    }

    const inputReason = document.getElementById("reason_sendToX").value;
    if (inputReason === "") {
      alert("Debe seleccionar una razon");
      return;
    }

    $("#btn_save_comment").click();
    update({ caseStatusId: CASE_STATUS.CONTROL_DESK, reasonHospitalSupervision: inputReason}, caseRecord.id).then((response) => {
      history.push("/mesa_control");
    });
  }

  const onClickSendCostControl = async () => {
    if (submitFormHospitalSupervision !== null) {
      await submitFormHospitalSupervision();
    }

    if (!isEmpty(submitFormHospitalSupervisionErrors)) {
      return;
    }

    const inputReason = document.getElementById("reason_sendToX").value;
    if (inputReason === "") {
      alert("Debe seleccionar una razon");
      return;
    }

    $("#btn_save_comment").click();
    update({ caseStatusId: CASE_STATUS.COST_CONTROL, reasonHospitalSupervision: inputReason}, caseRecord.id).then((response) => {
      history.push("/control_costos");
    });
  }

  const onClickSendMedicInformation = async () => {
    if (submitFormHospitalSupervision !== null) {
      await submitFormHospitalSupervision();
    }

    if (!isEmpty(submitFormHospitalSupervisionErrors)) {
      return;
    }

    const inputReason = document.getElementById("reason_sendToX").value;
    if (inputReason === "") {
      alert("Debe seleccionar una razon");
      return;
    }

    $("#btn_save_comment").click();
    update({ caseStatusId: CASE_STATUS.MEDIC_INFORMATION, reasonHospitalSupervision: inputReason}, caseRecord.id).then((response) => {
      history.push("/informacion_medica");
    });
  }

  if (!isCaseInCorrectModule(caseRecord, [CASE_STATUS.HOSPITAL_SUPERVISION])) {
    return <Redirect to="/error/unauthorized"/>;
  }

  return (
    <>
      <Alert
        variant="success"
        className="text-center"
        style={{ fontSize: "16px" }}
      >
        Supervision Hospitalaria
      </Alert>

      <CaseHeader caseRecord={caseRecord} />

      <BlockCaseContext.Provider value={[shouldBlockCase, setShouldBlockCase]}>
      <Accordion defaultActiveKey={query.has("from") && query.get("from") === "control_board" ? "" : "0"} className="mt-5">
        <InssuredData
          icon="fa-search"
          eventKey="1"
          data={caseRecord}
          disabledAll={true}
          bindSubmitForm={()=>{}}
        />
        <HospitalData
          icon="fa-search"
          eventKey="2"
          data={caseRecord}
          disabledAll={true}
          bindSubmitForm={()=>{}}
        />
        <Documentation
          icon ="fa-search"
          eventKey="4"
          data={caseRecord}
          disabledAll={query.has("from") && query.get("from") === "control_board"}
          typesDocument={[
            "Aviso de Accidente", "Carta de Autorización", "Comprobante de seguro o poliza", "Denuncia ante MP",
            "Estudios de Gabinete", "Estudios de Laboratorio", "Estudios que Confirmen DX", "Historia Clinica",
            "Honorarios Médicos", "Identificacion", "Informe Medico Actualizado", "Nota de Evolución",
            "Nota Postquirurgica", "Resumen Medico Actualizado", "Visado Final", "Otro",
          ]}
          {...props}
        />
        <AuthLetters
          icon="fa-search"
          showForm={false}
          hideDeleteOption={true}
          eventKey="3"
          data={caseRecord}
          disabledAll={false}
          setTotalLetters={setTotalLetters}
          {...props}
        />
        <SufferingData
          icon="fa-pencil-alt"
          eventKey="7"
          data={caseRecord}
          disabledAll={false}
          bindSubmitForm={() => {}}
        />
        <HospitalSupervision
          icon="fa-pencil-alt"
          eventKey="8"
          data={caseRecord}
          setCaseRecord={setCaseRecord}
          disabledAll={false}
          bindSubmitForm={bindSubmitFormHospitalSupervision}
          bindErrors={bindSubmitFormHospitalSupervisionErrors}
        />
      </Accordion>
      <Accordion defaultActiveKey="5" className="mt-5">
        <Binnacle
          icon="fa-pencil-alt"
          eventKey="5"
          data={caseRecord}
          disabledAll={false}
          eventStage={EVENT_STAGES[CASE_STATUS.HOSPITAL_SUPERVISION]}
          {...props}
        />
      </Accordion>
      </BlockCaseContext.Provider>

      <Row hidden={query.has("from") && query.get("from") === "control_board"}>
        <Col className="mt-5">
          <Button variant="primary" onClick={onClickSendControlDesk}>
            Enviar a Mesa de Control
          </Button>
        </Col>
        <Col className="mt-5">
          <Button variant="danger" onClick={onClickSendDictum}>
            Enviar a Dictamen
          </Button>
        </Col>
        <Col className="mt-5">
          <Button variant="warning" onClick={onClickSendCostControl}>
            Enviar a Control de Costos
          </Button>
        </Col>
        <Col className="mt-5">
          <Button variant="info" onClick={onClickSendMedicInformation}>
            Enviar a Informacion Médica
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Control
            className="mt-5 mr-3"
            as="select"
            name="reason_sendToX"
            id="reason_sendToX"
          >
            <option value="">Selecciona una opcion...</option>
            <option value="Finalizado sin Gestión">Finalizado sin Gestión</option>
            <option value="Finalizado con Gestión">Finalizado con Gestión</option>
            <option value="Finalizado con Gestión Pendiente">Finalizado con Gestión Pendiente</option>
            <option value="En Gestión">En Gestión</option>
          </Form.Control>
        </Col>
      </Row>
    </>
  );
};

export default WithCommentValidation(HospitalSupervisionDetails);

